import React from "react";
import "../../../Content/Styles/LiveGamesWidget.less";
import { MojCasinoHorizontal } from "./MojCasinoHorizontal.jsx";

export const LiveGamesWidget = (props) => {
    const selectedCategory = props.categories?.find(x => x.name === "Uživo");
    return (
        <div className="livegamesComponent">
            <div className="livegamesBackground" />
            <div className="livegamesVideo">
                <video autoPlay loop muted playsInline>
                    <source src="https://cdn.supersport.hr/casino/Images/LiveGamesWidget/LiveGames_display.mp4" type="video/mp4" />
                    Tvoj preglednik ne podržava video element.
                </video>
            </div>
            <div className="livegamesTitle">Igre Uživo</div>
            <button className="livegamesLearnMore">
                <a className="livegamesLinkAnchor" href="?game_category=uživo">
                    Prikaži sve
                </a>
            </button>
            <div className="livegamesGameList">
                <MojCasinoHorizontal
                    isAppIcon={true}
                    showSmall={false}
                    brojRedova={2}
                    showGameName={true}
                    randomSort={true}
                    randomSortOffset={21}
                    key="livegamesGameListHorizontal"
                    showAll={false}
                    {...props}
                    catId={selectedCategory?.id?.toString() || ""}
                    // GamePosition podaci, HizmanB
                    PageName="Home"
                    PositionType="component"
                    ComponentName="live-games"
                    ComponentPosition={props.index ?? 0}
                    IsIcon={true}
                />
            </div>
        </div>
    );
};